import { Component, inject } from '@angular/core';
import { BaseWidgetComponent } from '../../../../../home/home-widgets/widgets/base-widget.component';
import { DriverOperationsService, FilterService } from '../../../../../_shared/services';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AccountDateFilterRequest } from '../../../../../_shared/models/account-date-filter-request.model';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';
import { endOfDay, startOfDay } from 'date-fns';
import { DriversInVehicleModalComponent } from '../../modals/drivers-in-vehicle-modal/drivers-in-vehicle-modal.component';
import { KpiWidgetComponent } from '../../../../../_shared/components/kpi-widget/kpi-widget.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-drivers-in-vehicle-widget',
  standalone: true,
  imports: [KpiWidgetComponent, TranslocoPipe],
  templateUrl: './drivers-in-vehicle-widget.component.html',
  styleUrl: './drivers-in-vehicle-widget.component.scss',
})
export class DriversInVehicleWidgetComponent extends BaseWidgetComponent {
  private modalService = inject(NgbModal);
  private driverOperationsService = inject(DriverOperationsService);
  private errorHandlerService = inject(ErrorHandlerService);

  hasError: boolean = false;
  errorMessage: string = '';

  currentDate: Date = new Date();
  request: AccountDateFilterRequest = {
    accountIds: [],
    timeFrom: startOfDay(this.currentDate),
    timeTo: endOfDay(this.currentDate)
  };

  constructor() {
    const filterService = inject(FilterService);
    super(filterService);
    this.isLoading = true;
    this.hasError = false;
    this.errorMessage = '';
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    this.isLoading = true;
    this.request.accountIds = this.widgetFilter.accountIds;

    await this.getDriverInVehicle();
  }

  public override formatValue(value: number): string {
    return `${value.toLocaleString()}`;
  }

  public openDriverInVehicleModal(): void {
    if (this.value === 0) return;
    
    const options: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      size: 'lg',
    };

    const modalRef = this.modalService.open(DriversInVehicleModalComponent, options);
    modalRef.componentInstance.isModal = true;
    modalRef.componentInstance.paginationRequest.accountIds = this.widgetFilter.accountIds;
    modalRef.componentInstance.onFilterChangeAsync();
  }

  async getDriverInVehicle() {
    this.hasError = false;
    this.isLoading = true;

    try {
      this.cancelSubject.next();
      const response = await this.driverOperationsService.getDriverInVehicleSummary(this.request, this.cancelSubject);
      this.value = response.data?.totalDrivers ?? 0;

      this.isLoading = false;
    } catch (error: any) {
      this.errorHandlerService.handleError(error, {
        callback: (message) => {
          this.errorMessage = message;
          this.hasError = true;
          this.isLoading = false;
        }
      });
    }
  }
}